import { useMutation, useQueryClient } from "@tanstack/react-query";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateSellerSession } from "@/lib/query/core/invalidation";

type UpdateSellerPasswordInput = {
  storeSlug: string;
  currentPassword: string;
  nextPassword: string;
};

export function useUpdatePasswordMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (input: UpdateSellerPasswordInput) => {
      const { storeSlug, ...body } = input;
      void storeSlug;
      return apiJsonClient<unknown>(endpoints.seller.password, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
    },
    onSuccess: async (_data, variables) => {
      await invalidateSellerSession(queryClient, variables.storeSlug);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
